import { DATE_FORMAT } from "modules/common/constants";
import moment from "moment";

/** Текст по-русски: «Ё» рядом с «Е», числа внутри строки — по значению */
export function textComparator(valueA: string, valueB: string) {
    return (valueA || "").localeCompare(valueB || "", "ru", { numeric: true, sensitivity: "base" });
}

/** Номера приходят строками («9» и «10»): по строке они встали бы в обратном порядке */
export function numberComparator(valueA: string, valueB: string) {
    const left = parseInt(valueA, 10);
    const right = parseInt(valueB, 10);

    if (isNaN(left) && isNaN(right)) {
        return 0;
    }

    if (isNaN(left)) {
        return -1;
    }

    if (isNaN(right)) {
        return 1;
    }

    return left - right;
}

/** Даты приходят строками dd.MM.yyyy: по строке они сортируются по дню, а не по времени */
export function dateComparator(valueA: string, valueB: string) {
    const left = valueA ? moment(valueA, DATE_FORMAT).valueOf() : 0;
    const right = valueB ? moment(valueB, DATE_FORMAT).valueOf() : 0;

    return left - right;
}
